import { useEffect } from 'react';
import { Conversation } from '../models/Notification';
import { User } from '../models/User';

export default function useOpenConversationFromParam({
  currentUser,
  users,
  conversations,
  setSelectedConversation,
  setOtherUser,
  setSelectedRecipient,
  setShowMessageComposer
}: {
  currentUser: User;
  users: User[];
  conversations: Conversation[];
  setSelectedConversation: (c: Conversation | null) => void;
  setOtherUser: (u: User | null) => void;
  setSelectedRecipient: (u: User | null) => void;
  setShowMessageComposer: (v: boolean) => void;
}) {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('user');
    if (userId) {
      const targetUser = users.find(u => u.id === userId);
      if (targetUser) {
        let conversation = conversations.find(c =>
          c.participants.includes(currentUser.id) && c.participants.includes(userId)
        );
        if (conversation) {
          setOtherUser(targetUser);
          setSelectedConversation(conversation);
        } else {
          setSelectedRecipient(targetUser);
          setShowMessageComposer(true);
        }
      }
      // Clear the param
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [currentUser, users, conversations, setSelectedConversation, setOtherUser, setSelectedRecipient, setShowMessageComposer]);
} 